import { Box, Drawer, Stack, Typography, List, Divider, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import ImageFromBase64 from "../../components/imageProfile";
import API from "../../api";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useLocation } from "react-router-dom";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import { LicenseIcon } from "../../components/GeneralIcons";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import FolderIcon from '@mui/icons-material/Folder';
import CodeIcon from "@mui/icons-material/Code";
import { LecsWhiteIcon } from "../../components/LecsIcon";
import MovingIcon from "@mui/icons-material/Moving";
import ReportIcon from "@mui/icons-material/Report";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CampaignIcon from "@mui/icons-material/Campaign";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import MapIcon from "@mui/icons-material/Map";
import SummarizeIcon from '@mui/icons-material/Summarize';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";
import DatasetIcon from "@mui/icons-material/Dataset";
import Item from "../../components/SidebarItem";
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { MoveDown } from "@mui/icons-material";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import PrecisionManufacturing from "@mui/icons-material/PrecisionManufacturing"
import SecurityIcon from '@mui/icons-material/Security';
import PolicyIcon from '@mui/icons-material/Policy';

const SidebarR = ({ customerName, isCollapsed, handleChange }) => {
  const location = useLocation();
  const [drawerWidth, setDrawerWidth] = useState(isCollapsed ? 80 : 240);
  const [image, setImage] = useState();
  const [imageType, setImageType] = useState();
  const [companyName, setCompanyName] = useState();
  const [nome, setNome] = useState();
  const [cognome, setCognome] = useState();
  const [selected, setSelected] = useState(location.pathname);
  const [otEnabled, setOtEnabled] = useState(false);
  const [orionEnabled, setOrionEnabled] = useState(false);

  const pages = [
    { data: { icon: <HomeOutlinedIcon />, title: "Overview", to: "/reseller/home" } },
    { data: { title: "Security Operation Center" } },
    { data: { icon: <PeopleAltIcon />, title: "Customer Management", to: "/reseller/myC/customers" } },
    { data: { icon: <ViewTimelineIcon />, title: "NFR", to: "/reseller/myC/nfr" } },
    { data: { icon: <PictureAsPdfIcon />, title: "Report PDF", to: "/reseller/myC/AutomaticReport" } },
    (customerName ? {
      header: { title: customerName, icon: <ManageAccountsIcon /> },
      data: [
        { icon: <LecsWhiteIcon />, title: "LECS Management", to: "/reseller/myC/lecs-management" },
        { icon: <HomeOutlinedIcon />, title: "Home-Customer", to: "/reseller/myC/dashboard" },
        { title: "Security" },
        { icon: <MovingIcon />, title: "Highlights", to: "/reseller/myC/highlights" },
        { icon: <DatasetIcon />, title: "Aggregations", to: "/reseller/myC/aggregations" },
        { title: "Detection & Response" },
        { icon: <ReportIcon />, title: "Critical", to: "/reseller/myC/critical" },
        { icon: <HighlightOffIcon />, title: "High", to: "/reseller/myC/high" },
        { title: "Detection" },
        { icon: <CampaignIcon />, title: "Alert", to: "/reseller/myC/alert" },
        { icon: <GraphicEqIcon />, title: "Movements", to: "/reseller/myC/movements" },
        { title: "Antlia" },
        { icon: <SecurityIcon />, title: "Security", to: "/reseller/myC/ot-security", disabled: !otEnabled },
        { icon: <MoveDown />, title: "Monitor", to: "/reseller/myC/ot-monitor", disabled: !otEnabled },
        // { icon: <MoveDown />, title: "OT writes", to: "/user/security/ot-writes" },
        // { icon: <VisibilityIcon />, title: "OT Reads", to: "/user/security/ot-reads" },
        { icon: <PrecisionManufacturing />, title: "History", to: "/reseller/myC/ot-protocols", disabled: !otEnabled },
        { icon: <DisplaySettingsIcon />, title: "Tags", to: "/reseller/myC/ot-configuration", disabled: !otEnabled },
        { title: "Intelligence" },
        { icon: <CrisisAlertIcon />, title: "Threat Intelligence", to: "/reseller/myC/threat-intelligence" },
        { icon: <MapIcon />, title: "Map", to: "/reseller/myC/extra/map" },
        { title: "Tool" },
        { icon: <SummarizeIcon />, title: "Generate Report", to: "/reseller/myC/report" },
        { title: "Tires-IA Engine" },
        { icon: <BlurOnIcon />, title: "Tires-IA Analysis", to: "/reseller/myC/tiresia-analysis" },
        { icon: <WarningAmberIcon />, title: "Incident Analysis", to: "/reseller/myC/incident-context" },
        { title: "Network" },
        { icon: <AnalyticsIcon />, title: "Overview", to: "/reseller/myC/overview" },
        { icon: <PermDataSettingIcon />, title: "Inventory", to: "/reseller/myC/status" },
        { icon: <PolicyIcon />, title: "Network Zones", to: "/reseller/myC/network-status/zones", disabled: !orionEnabled, disabledReason: "Orion module is disabled" },
        { icon: <WebStoriesIcon />, title: "Infrastructure Log", to: "/reseller/myC/infrastructure-log" }
      ]
    } : null),
    { data: { title: "Partner Management" } },
    { data: { icon: <ManageAccountsIcon />, title: "Account Management", to: "/reseller/account_management" } },
    { data: { icon: <AdminPanelSettingsRoundedIcon />, title: "Deal Protection", to: "/reseller/deal-protection" } },
    { data: { icon: <LicenseIcon />, title: "License Management", to: "/reseller/licenses" } },
    { data: { icon: <WebStoriesIcon />, title: "History Logs", to: "/reseller/logs" } },
    { data: { icon: <CodeIcon />, title: "API Documentation", to: "/reseller/api-documentation" } },
    { data: { title: "Support" } },
    { data: { icon: <LocalActivityIcon />, title: "Tickets", to: "/reseller/tickets" } },
    { data: { icon: <FolderIcon />, title: "Documentation", to: "/reseller/document" } }
  ]

  useEffect(() => {
    if (sessionStorage.getItem('ragioneSociale') && sessionStorage.getItem('nomeUser') && sessionStorage.getItem('cognomeUser')) {
      setImage(sessionStorage.getItem('profileImage') || "");
      setCompanyName(sessionStorage.getItem('ragioneSociale') || "");
      setImageType(sessionStorage.getItem('imageType') || "");
      setNome(sessionStorage.getItem('nomeUser') || "");
      setCognome(sessionStorage.getItem('cognomeUser') || "");
    } else {
      API.getDataUsers().then((result) => {
        setImage(result.data.profileImage);
        setCompanyName(result.data.ragioneSociale);
        setImageType(result.data.imageType);
        setNome(result.data.nome);
        setCognome(result.data.cognome);
        sessionStorage.setItem("profileImage", result.data.profileImage);
        sessionStorage.setItem("ragioneSociale", result.data.ragioneSociale);
        sessionStorage.setItem("imageType", result.data.imageType);
        sessionStorage.setItem("nomeUser", result.data.nome);
        sessionStorage.setItem("cognomeUser", result.data.cognome);
      }).catch((error) => {
        console.error('[SidebarR] error:', error);
      });
    }
  }, []);

  useEffect(() => {
    if (isCollapsed) setDrawerWidth(80);
    else setDrawerWidth(240);
  }, [isCollapsed]);

  useEffect(() => {
    if (!customerName) {
      setOtEnabled(false);
      setOrionEnabled(false);
      return;
    }
    API.getCustomerFeatures()
      .then(res => {
        setOtEnabled(res.data.otModule);
        setOrionEnabled(res.data.orionModule);
      })
      .catch(() => {
        setOtEnabled(false);
        setOrionEnabled(false);
      });
  }, [customerName]);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": { width: drawerWidth }
      }}
    >
      <Stack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'top'} height={'100%'} minWidth={0} width={"100%"}>
        {!isCollapsed ? (
          <>
            <img
              src="/logo-lecs.png"
              alt="LECS"
              style={{ width: "auto", height: "50px", alignSelf: "start" }}
            />

            <Box sx={{ display: "flex", width: "max-content", borderRadius: "50%" }}>
              <ImageFromBase64 base64Data={image} format={imageType} style={{ width: "100px" }} />
            </Box>

            <Typography variant="h4" fontWeight="bold">
              {companyName}
            </Typography>

            <Typography variant="h6">
              {nome} {cognome}
            </Typography>
          </>
        ) : (
          <Box sx={{ display: "flex", width: "max-content", backgroundColor: 'transparent', borderRadius: "50%", pt: 5 }}>
            <ImageFromBase64 base64Data={image} format={imageType} style={{ width: "50px", height: "50px" }} />
          </Box>
        )}

        <Box height={"100%"} overflow={"auto"} px={2} minWidth={0} width={"100%"}>
          <List>
            {
              pages.filter(page => page != null).map((page, index) => (
                <Item
                  key={index}
                  data={page.data}
                  header={page?.header}
                  isCollapsed={isCollapsed}
                  selected={selected}
                  setSelected={setSelected}
                />
              ))
            }
          </List>
        </Box>

        <Divider flexItem />
        <Stack direction={"row"} spacing={1} p={1.5} width={"100%"} justifyContent={isCollapsed ? 'center' : 'space-between'} alignItems={"center"}>
          {!isCollapsed ? (
            <Typography fontSize={12} display={"flex"} alignItems={"center"}>
              v8.6
            </Typography>
          ) : (
            <div />
          )}
          <IconButton onClick={() => handleChange()}>
            {isCollapsed ? <MenuIcon /> : <ArrowBackIosNewIcon />}
          </IconButton>
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default SidebarR;